
/**
 * 콘텐츠 유형
 */
export type LectureDetailContentType = typeof LectureDetailContentType[keyof typeof LectureDetailContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LectureDetailContentType = {
  VIDEO: 'VIDEO',
  ARTICLE: 'ARTICLE',
  QUIZ: 'QUIZ',
  ASSIGNMENT: 'ASSIGNMENT',
} as const;
